// extracted by mini-css-extract-plugin
module.exports = {"recruitementPatternInformation__title":"RecruitmentPatternInformation_recruitementPatternInformation__title__QreCz"};